export const isFilePasswordProtected = async (file: File) => {
  if (file.type !== 'application/pdf' && !file.name.endsWith('.pdf')) return false

  const content = await file.text()
  return (
    content.includes('Encrypt') &&
    content.substring(content.lastIndexOf('<<'), content.lastIndexOf('>>')).includes('/Encrypt')
  )
}

export const downloadFile = (content: string, filename: string, contentType: string): void => {
  const blob = new Blob([content], { type: contentType })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
